<template>
  <div class="offer">
    <div class="info">
      <div>
        <div class="title">
          🚀 极速连接 · 世界第一
        </div>
        <div class="desc">
          采用全球顶级服务器集群和智能路由技术，连接速度比行业平均水平快300%。无论是8K视频、大型游戏还是文件传输，都能享受闪电般的极速体验，零缓冲、零等待。
        </div>
      </div>
      <div style="order: -1;" class="img">
        <div class="icon-wrapper speed-icon">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="speedGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
              </linearGradient>
            </defs>
            <!-- Rocket body -->
            <path d="M100 30 L120 100 L110 140 L90 140 L80 100 Z" fill="url(#speedGradient)"/>
            <!-- Rocket window -->
            <circle cx="100" cy="70" r="12" fill="#fff" opacity="0.9"/>
            <!-- Rocket fins -->
            <path d="M80 100 L60 130 L80 120 Z" fill="url(#speedGradient)" opacity="0.8"/>
            <path d="M120 100 L140 130 L120 120 Z" fill="url(#speedGradient)" opacity="0.8"/>
            <!-- Flame -->
            <ellipse cx="100" cy="145" rx="15" ry="25" fill="#ffd700" opacity="0.8"/>
            <ellipse cx="100" cy="150" rx="10" ry="20" fill="#ff6b6b" opacity="0.6"/>
            <!-- Speed lines -->
            <line x1="50" y1="60" x2="30" y2="60" stroke="#667eea" stroke-width="3" opacity="0.5"/>
            <line x1="50" y1="80" x2="25" y2="80" stroke="#667eea" stroke-width="3" opacity="0.5"/>
            <line x1="50" y1="100" x2="20" y2="100" stroke="#667eea" stroke-width="3" opacity="0.5"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="info">
      <div>
        <div class="title">
          🛡️ 军事级加密 · 绝对安全
        </div>
        <div class="desc">
          采用AES-256军事级加密标准，配合零日志政策和DNS泄露保护，确保您的数据绝对安全。通过独立安全审计认证，隐私保护达到银行级别，让您的在线活动完全匿名。
        </div>
      </div>
      <div class="img">
        <div class="icon-wrapper security-icon">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="securityGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
              </linearGradient>
            </defs>
            <!-- Shield -->
            <path d="M100 20 L160 50 L160 100 Q160 150 100 180 Q40 150 40 100 L40 50 Z" 
                  fill="url(#securityGradient)" opacity="0.9"/>
            <!-- Lock body -->
            <rect x="80" y="95" width="40" height="45" rx="5" fill="#fff" opacity="0.95"/>
            <!-- Lock shackle -->
            <path d="M85 95 L85 75 Q85 60 100 60 Q115 60 115 75 L115 95" 
                  stroke="#fff" stroke-width="8" fill="none" opacity="0.95"/>
            <!-- Keyhole -->
            <circle cx="100" cy="110" r="5" fill="url(#securityGradient)"/>
            <rect x="97" y="110" width="6" height="15" fill="url(#securityGradient)"/>
            <!-- Checkmark -->
            <path d="M70 120 L85 135 L130 90" stroke="#ffd700" stroke-width="6" 
                  fill="none" stroke-linecap="round" opacity="0.8"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="info">
      <div>
        <div class="title">
          ⚡ 一键启动 · 极致简单
        </div>
        <div class="desc">
          无需任何技术知识，一键即可连接全球200+优质节点。智能推荐最佳服务器，自动优化网络性能，让您专注于内容本身，而非繁琐的设置。
        </div>
      </div>
      <div style="order: -1;" class="img">
        <div class="icon-wrapper simple-icon">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="simpleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
              </linearGradient>
            </defs>
            <!-- Hand/Finger -->
            <ellipse cx="100" cy="140" rx="35" ry="45" fill="url(#simpleGradient)" opacity="0.9"/>
            <rect x="85" y="100" width="30" height="60" fill="url(#simpleGradient)" opacity="0.9"/>
            <!-- Button -->
            <circle cx="100" cy="80" r="45" fill="#ffd700" opacity="0.9"/>
            <circle cx="100" cy="80" r="35" fill="#fff" opacity="0.95"/>
            <!-- Power symbol -->
            <line x1="100" y1="65" x2="100" y2="85" stroke="url(#simpleGradient)" 
                  stroke-width="6" stroke-linecap="round"/>
            <path d="M85 75 Q85 60 100 60 Q115 60 115 75" stroke="url(#simpleGradient)" 
                  stroke-width="6" fill="none" stroke-linecap="round"/>
            <!-- Click effect circles -->
            <circle cx="100" cy="80" r="50" stroke="#667eea" stroke-width="2" 
                    fill="none" opacity="0.3"/>
            <circle cx="100" cy="80" r="55" stroke="#667eea" stroke-width="2" 
                    fill="none" opacity="0.2"/>
          </svg>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'Offer',
    components: {},
    setup () {

    },
    created () {
    }
  }
</script>

<style scoped>
  div {
    text-align: center;
  }

  img {
    max-width: 200px;
    transition: transform 0.3s ease;
  }

  .icon-wrapper {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    transition: transform 0.3s ease;
  }

  .icon-wrapper svg {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 4px 12px rgba(102, 126, 234, 0.2));
  }

  .info:hover .icon-wrapper {
    transform: scale(1.05);
  }

  .speed-icon svg line {
    animation: speedLines 1.5s ease-in-out infinite;
  }

  .security-icon svg path:last-child {
    animation: checkmark 2s ease-in-out infinite;
  }

  .simple-icon svg circle:nth-last-child(2),
  .simple-icon svg circle:last-child {
    animation: ripple 2s ease-out infinite;
  }

  @keyframes speedLines {
    0%, 100% {
      opacity: 0.3;
      transform: translateX(0);
    }
    50% {
      opacity: 0.7;
      transform: translateX(-5px);
    }
  }

  @keyframes checkmark {
    0%, 100% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
  }

  @keyframes ripple {
    0% {
      opacity: 0.3;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1.2);
    }
  }

  .offer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem 4%;
    gap: 2.5rem;
  }

  .title {
    font-size: 2.2rem;
    font-weight: 800;
    margin: 1.5rem 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .desc {
    color: #4a5568;
    padding: 0.5rem 2rem;
    font-size: 1.05rem;
    line-height: 1.7;
    font-weight: 400;
  }

  .info {
    width: 100%;
    max-width: 900px;
    background: #ffffff;
    border: none;
    border-radius: 24px;
    padding: 2.5rem 2rem;
    box-shadow: 0 10px 40px rgba(0,0,0,0.08);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .info::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  }

  .info:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 60px rgba(102,126,234,0.15);
  }

  @media all and (max-width: 799px) {
    .offer {
      padding: 2rem 3%;
      gap: 2rem;
    }
    .info {
      padding: 2rem 1.5rem;
    }
    .title {
      font-size: 1.8rem;
    }
    .desc {
      font-size: 1rem;
      padding: 0.5rem 1rem;
    }
    .icon-wrapper {
      width: 150px;
      height: 150px;
    }
  }

  @media all and (min-width: 800px) {
    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 3rem 3.5rem;
      gap: 3rem;
    }

    .info > div:first-child {
      flex: 1;
      text-align: left;
    }

    .info .title {
      text-align: left;
      font-size: 2.5rem;
    }

    .info .desc {
      text-align: left;
      padding: 0.5rem 0;
    }

    .info .img {
      flex-shrink: 0;
      width: 280px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
